import api from './api'

const getAll = () => api.nodes.get('users/me/nodes').then(res => res.data)

const getAllClusters = () =>
  api.nodes.get('users/me/clusters').then(res => res.data)

const updateClusterAlias = (clusterId, alias) =>
  api.nodes
    .post(`users/me/clusters/${clusterId}/alias`, { alias })
    .then(res => res.data)

const deleteNode = nodeId =>
  api.nodes.delete(`users/me/nodes/${nodeId}`).then(res => res.data)

const deleteCluster = clusterId =>
  api.nodes.delete(`users/me/clusters/${clusterId}`).then(res => res.data)

const getServices = (type = 'nodes') =>
  api.nodes.get(`services/${type}`).then(res => res.data)

// eslint-disable-next-line complexity
function getNodePort(node) {
  switch (node.chain) {
    case 'eth':
    case 'etc':
    case 'polygon':
      return 8545

    case 'bch':
    case 'btc':
      return node.network === 'testnet' ? 18332 : 8332

    case 'qtumindexed':
      return node.network === 'testnet' ? 13889 : 3889

    case 'ltc':
      return node.network === 'testnet' ? 19332 : 9332

    case 'avalanche':
      return 9650
  }
  return undefined
}

function getAuthString(auth) {
  switch (auth.type) {
    case 'basic':
      return `-u ${auth.user}:${auth.pass} `
    case 'jwt':
      return '-H "Authorization: Bearer $CLIENT_ACCESS_TOKEN" '
    default:
      return ''
  }
}

// eslint-disable-next-line complexity
function getNodeConnectionSample(node, insecure) {
  const port = getNodePort(node)
  const auth = getAuthString(node.auth)

  const curl = insecure ? 'curl -k' : 'curl'
  const host = `${node.ip || node.domain}:${port}`

  switch (node.chain) {
    case 'bch':
    case 'btc':
    case 'ltc':
    case 'qtumindexed':
      return `${curl} ${auth}-X GET https://${host}/rest/chaininfo.json`

    case 'etc':
    case 'eth':
    case 'polygon':
      return (
        `${curl} ${auth}-X POST -H "Content-Type: application/json"` +
        ` --data '{"jsonrpc":"2.0","method":"eth_blockNumber","params":[],"id":"1"}'` +
        ` https://${host}`
      )

    case 'avalanche':
      return (
        `${curl} ${auth}-X POST -H 'content-type:application/json'` +
        ` --data '{"jsonrpc":"2.0","method":"health.getLiveness","id":"1"}'` +
        ` https://${host}/ext/health`
      )

    default:
      return 'Unknown chain'
  }
}

export default {
  getNodeConnectionSample,
  getAllClusters,
  updateClusterAlias,
  deleteCluster,
  getServices,
  deleteNode,
  getAll
}
